import React, { useContext } from "react";
import Modal from "Components/smallModal/smallModal";
import Button from "Components/button/Button";
import RadioButton from "Components/radiobutton/RadioButton";
import useFormState from "Utils/useFormState";
import { MediaQueriesContext } from "@/App";
import cx from "classnames";
import { t } from "i18next";
import TranslatedString from "Components/TranslatedString";
import QboxmailApi from "@/qboxmailApi";
import { alertError } from "../../utils/alerts";

const api = new QboxmailApi({ useCookie: true });

const DeclareTypeModal = ({ userCode, isOpen, handleClose, onSave }) => {
  const { setFormFieldValue, formData, setFormLoading, unsetFormLoading, isFormLoading } = useFormState();
  const { isMediaMobile } = useContext(MediaQueriesContext);

  const onSubmit = async () => {
    if (formData.type) {
      try {
        setFormLoading();
        await api.editAccount(userCode, { declared_type: formData.type });

        if (onSave) {
          await onSave();
        }

        unsetFormLoading();
        handleClose();
      } catch (error) {
        alertError(t("alert.wrong"));
      }
    }
  };

  return (
    <Modal
      title={t("modal.resellerOrCompany.title")}
      opened={isOpen}
      closeModal={() => {}}
      withForm
      mediumModal={!isMediaMobile}
    >
      <div className="mt-3">
        <div>
          <TranslatedString>modal.resellerOrCompany.desc</TranslatedString>
        </div>
        <div className={cx("flex p-1 mt-8", { ["flex-col"]: isMediaMobile })}>
          <div
            className={cx("flex-1", {
              ["border-r-[1px] border-r-qb-border-gray pl-2 pr-6"]: !isMediaMobile,
              ["mb-6 px-2"]: isMediaMobile,
            })}
          >
            <div className="font-[--bold]">{t("modal.resellerOrCompany.reseller.title")}</div>
            <div className="mt-2 mb-4">
              <TranslatedString>modal.resellerOrCompany.reseller.desc</TranslatedString>
            </div>
            <RadioButton
              //eslint-disable-next-line
              children={[{ value: "reseller", label: t("modal.resellerOrCompany.reseller.input.label") }]}
              name="type0"
              onChange={(obj) => setFormFieldValue({ type: obj.type0 })}
              value={formData.type}
            />
          </div>
          <div className={cx("flex-1", { ["px-2"]: isMediaMobile, ["pl-5 pr-6"]: !isMediaMobile })}>
            <div className="font-[--bold]">{t("modal.resellerOrCompany.company.title")}</div>
            <div className="mt-2 mb-4">
              <TranslatedString>modal.resellerOrCompany.company.desc</TranslatedString>
            </div>

            <RadioButton
              //eslint-disable-next-line
              children={[{ value: "company", label: t("modal.resellerOrCompany.company.input.label") }]}
              name="type1"
              onChange={(obj) => setFormFieldValue({ type: obj.type1 })}
              value={formData.type}
            />
          </div>
        </div>
        <div className="flex justify-center my-5">
          <Button loading={isFormLoading} onClick={onSubmit} disabled={!formData.type}>
            modal.resellerOrCompany.submitButton
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeclareTypeModal;
